import styled from 'styled-components';

interface Props {
  tipo: string;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Date = styled.span`
  font-weight: 700;
  flex: 1;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Descricao = styled.span`
  font-weight: 700;
  font-size: 12px;
  flex: 1;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Id = styled.span`
  font-weight: 700;
  font-size: 12px;
  flex: 1;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Tipo = styled.span`
  font-weight: 700;
  font-size: 12px;
  flex: 1;
  text-align: center;
`;

export const Valor = styled.span`
  font-weight: 700;
  font-size: 12px;
  flex: 1;
  text-align: right;
  display: flex;
  justify-content: flex-end;
`;

export const NovoBalanco = styled.span<Props>`
  font-weight: 700;
  font-size: 12px;
  flex: 1;
  text-align: right; 
  color: ${props => props.tipo !== 'Saque' ? props.theme.colors.positive : props.theme.colors.negative}
`;

export const Status = styled.span`
  width: 120px;
  font-weight: 700;
  font-size: 12px;
  text-align: center;
`;

export const Icon = styled.div`
  width: 30px;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const ItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
  padding-block: 20px;
  background-color: ${props => props.theme.colors.card_300};
  border-radius: 10px;
  justify-content: flex-start;
  gap: 10px;  
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  flex-wrap: wrap;

  cursor: pointer;
`;


export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
  background-color: ${props => props.theme.colors.card_200};
  border-radius: 10px;
  justify-content: flex-start;
  gap: 10px;
  font-weight: 700;
  text-transform: uppercase;
`;

export const DateHeader = styled.span`
  flex: 1;
  text-align: center;
  font-size: 12px;
`;

export const DescricaoHeader = styled.span`
  flex: 1;
  text-align: center;
  font-size: 12px;
`;

export const IdHeader = styled.span`
  flex: 1;
  text-align: center;
  font-size: 12px;
`;

export const ObservacaoHeader = styled.span`
  flex: 1;
  text-align: center;
  font-size: 12px;
`;

export const TipoHeader = styled.span`
  flex: 1;
  text-align: center;
  font-size: 12px;
`;

export const StatusHeader = styled.span`
  width: 120px;
  text-align: center;
  font-size: 12px;
`;

export const ValorHeader = styled.span`
  flex: 1;
  text-align: right;
  font-size: 12px;
`;

export const IconHeader = styled.div`
  width: 30px;
  display: flex;
  justify-content: center;
`;